import { Navigate } from "@tanstack/react-router";
import type React from "react";
import { WorkspaceOverviewPage } from "@/pages/workspace-overview";
import { usePortfolio } from "@/providers/PortfolioProvider";

export const PortfolioOverview: React.FC = () => {
  const { enabled, merchants } = usePortfolio();

  if (enabled === false) return <Navigate to="/" />;
  return <WorkspaceOverviewPage merchants={merchants} />;
};
